// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
type Primitive = string | Function | number | boolean | symbol | undefined | null;

type DeepOmitArray<T extends unknown[], K> = {
  [P in keyof T]: DeepOmit<T[P], K>;
};

export type DeepOmit<T, K> = T extends Primitive
  ? T
  : {
      [P in Exclude<keyof T, K>]: T[P] extends infer TP
        ? TP extends Primitive
          ? TP // leave primitives and functions alone
          : TP extends unknown[]
            ? DeepOmitArray<TP, K> // Array special handling
            : DeepOmit<TP, K>
        : never;
    };

export type DeepOmitTypeName<T> = DeepOmit<T, '__typename'>;

export const deepOmitTypeName = <T>(obj: T): DeepOmitTypeName<T> => {
  return JSON.parse(JSON.stringify(obj), (key: string, value: unknown) =>
    key === '__typename' ? undefined : value,
  ) as DeepOmitTypeName<T>;
};
